module.exports = __webpack_public_path__ + "img/course_img2.36702655.png";